import React from "react";
import {
  logoTitle,
  copyright,
  tosLink,
  cookiesLink,
  privacyLink
} from "../config";
import styles from "../styles/footer.module.scss";

const Footer = () => {
  const copyrights = copyright.replace("__date__", new Date().getFullYear());
  return (
    <div className={styles.footer}>
      <p className={styles.logoTitle}>{logoTitle}</p>
      <p className={styles.links}>
        <a href={tosLink} target="_blank" rel="noopener noreferrer">
          Terms of service
        </a>
        <span>, </span>
        <a href={privacyLink} target="_blank" rel="noopener noreferrer">
          Privacy policy
        </a>
        <span> and </span>
        <a href={cookiesLink} target="_blank" rel="noopener noreferrer">
          Cookies
        </a>
      </p>
      <p className={styles.copyright}>{copyrights}</p>
    </div>
  );
};

export default Footer;
